import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Linkedin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer
      data-testid="main-footer"
      className="relative bg-[#0B132B] text-slate-300 overflow-hidden"
    >
      <div className="absolute inset-0 aje-grid-bg opacity-40" />
      <div className="absolute -top-32 -right-24 h-72 w-72 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
            {/* LOGO PERUSAHAAN */}
            <img src={COMPANY.logo} alt="AJE" className="h-9 w-auto" />

            {/* TEXT CONTAINER DENGAN GARIS VERTIKAL (BORDER KIRI) */}
            <div className="flex flex-col justify-between pl-3 border-l-[1.5px] border-white text-white leading-none">
            <span className="font-sans text-[11px] font-normal tracking-widest block">
            ANEKA
          </span>
          <span className="font-sans text-[11px] font-normal tracking-widest block py-0.5">
            JARINGAN
          </span>
          <span className="font-sans text-[11px] font-normal tracking-widest block">
            ENERGY
          </span>
        </div>
      </div>
            <p className="mt-5 text-sm leading-relaxed text-slate-400">
              A renewable energy EPC company committed to delivering reliable, innovative, and sustainable solar solutions for a greener planet.
            </p>
            <a
              href={COMPANY.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            >
              <Linkedin className="h-4 w-4" /> LinkedIn
            </a>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-5">Navigation</h4>
            <ul className="space-y-3 text-sm">
              {[
                ["Home", "/"],
                ["About Us", "/tentang"],
                ["Service & Product", "/layanan"],
                ["Project", "/proyek"],
                ["Article", "/artikel"],
                ["Contact", "/kontak"],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="inline-flex items-center gap-1 text-slate-400 transition-colors hover:text-emerald-400"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-5">Services</h4>
            <ul className="space-y-3 text-sm">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <Link
                    to="/layanan"
                    className="text-slate-400 transition-colors hover:text-emerald-400"
                  >
                    {s.title.split("(")[0].trim()}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-5">Contact Us</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex gap-3">
                <MapPin className="h-5 w-5 shrink-0 text-emerald-400" />
                <span className="text-slate-400">{COMPANY.address}</span>
              </li>
              <li className="flex gap-3">
                <Phone className="h-5 w-5 shrink-0 text-emerald-400" />
                <a href={`tel:${COMPANY.phoneRaw}`} className="text-slate-400 hover:text-white">
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex gap-3">
                <Mail className="h-5 w-5 shrink-0 text-emerald-400" />
                <a href={`mailto:${COMPANY.email}`} className="text-slate-400 hover:text-white">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex gap-3">
                <Clock className="h-5 w-5 shrink-0 text-emerald-400" />
                <span className="text-slate-400">{COMPANY.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-slate-500">
             A Part of {COMPANY.parent}
          </p>
        </div>
      </div>
    </footer>
  );
}
